import { Routes, Route, Navigate } from "react-router-dom";
import SiteLayout from "../layouts/SiteLayout";

import HomePage from "../pages/user/HomePage";
import PropertiesPage from "../pages/user/PropertiesPage";
import PropertyDetailsPage from "../pages/user/PropertyDetailsPage";
import ContactPage from "../pages/user/ContactPage";
import ReviewsPage from "../pages/user/ReviewsPage";
import PrivacyPolicyPage from "../pages/user/PrivacyPolicyPage";
import TermsPage from "../pages/user/TermsPage";

import AdminLayout from "../pages/admin/AdminLayout";
import AdminLoginPage from "../pages/admin/LoginPage";
import RequireAdmin from "../pages/admin/RequireAdmin";
import AdminPropertiesPage from "../pages/admin/PropertiesPage";
import AdminNewPropertyPage from "../pages/admin/NewPropertyPage";
import AdminEditPropertyPage from "../pages/admin/EditPropertyPage";
import AdminAvailabilityPage from "../pages/admin/AvailabilityPage";
import AdminMessagesPage from "../pages/admin/MessagesPage";
import AdminBookingsListPage from "../pages/admin/bookings/BookingsListPage";
import AdminBookingDetailsPage from "../pages/admin/bookings/BookingDetailsPage";
import AdminBookingCreatePage from "../pages/admin/bookings/AdminBookingCreatePage";
import AdminBookingsCalendarPage from "../pages/admin/bookings/AdminBookingsCalendarPage";

import AdminBookingInquiriesListPage from "../pages/admin/bookingInquiries/AdminBookingInquiriesListPage";
import AdminBookingInquiryDetailsPage from "../pages/admin/bookingInquiries/AdminBookingInquiryDetailsPage";
import AdminFeaturesPage from "pages/admin/FeaturesPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/el" replace />} />

      <Route path="/:locale" element={<SiteLayout />}>
        <Route index element={<HomePage />} />

        <Route path="properties" element={<PropertiesPage />} />
        <Route path="properties/:slug" element={<PropertyDetailsPage />} />

        <Route path="contact" element={<ContactPage />} />
        <Route path="reviews" element={<ReviewsPage />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="terms" element={<TermsPage />} />

        <Route path="admin">
          <Route index element={<Navigate to="properties" replace />} />
          <Route path="login" element={<AdminLoginPage />} />

          <Route
            element={
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            }
          >
            <Route path="properties" element={<AdminPropertiesPage />} />
            <Route path="properties/:id" element={<AdminEditPropertyPage />} />
            <Route path="availability" element={<AdminAvailabilityPage />} />
            <Route path="new-property" element={<AdminNewPropertyPage />} />

            {/* Bookings */}
            <Route path="bookings" element={<AdminBookingsListPage />} />
            <Route path="bookings/new" element={<AdminBookingCreatePage />} />
            <Route path="bookings/calendar" element={<AdminBookingsCalendarPage />} />
            <Route path="bookings/:id" element={<AdminBookingDetailsPage />} />
            <Route path="features" element={<AdminFeaturesPage />} />

            {/* Booking Inquiries (ΑΙΤΗΜΑΤΑ ΚΡΑΤΗΣΗΣ) */}
            <Route path="booking-inquiries" element={<AdminBookingInquiriesListPage />} />
            <Route path="booking-inquiries/:id" element={<AdminBookingInquiryDetailsPage />} />

            <Route path="messages" element={<AdminMessagesPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/el" replace />} />
    </Routes>
  );
}
